import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Departement } from "../models/departement";
import { HttpHeadersService } from '@perval/shared';
import { fromDepartementHttpToDepartement } from "./mappers/departements.mappers";
import { firstValueFrom, map } from 'rxjs';
import { DepartementsHttp } from '../models/departements-http';


@Injectable({
  providedIn: 'root',
})
export class Statistics {
    private readonly mainUrl = `http://localhost:8038/perval-geo`;
    
    constructor(
        private readonly http: HttpClient,
        private readonly httpHeadersServiceService: HttpHeadersService,
    ) {}

    async getDepartements () : Promise<Departement[]> {
      return firstValueFrom(
        this.http
          .get<DepartementsHttp>(`${this.mainUrl}/departement`, {
            headers:
              await this.httpHeadersServiceService.getHeadersWithPervalContext(),
          })
          .pipe(map((departementsHttp) => departementsHttp.items.map(fromDepartementHttpToDepartement))), 
      );
    }
}

